import React, { Component } from "react"
import { withRouter } from "react-router-dom"

class Table extends Component {
  render() {
    return (
      <div className={this.props.sizeClass}>
        <div className="card">
          <div
            className="card-header"
            data-background-color={this.props.backgroundColor}
          >
            <h4 className="title text-center">{this.props.title}</h4>
            <p className="category">{this.props.subtitle}</p>
          </div>
          <div className="card-content table-responsive">
            <table className="table table-hover">
              <thead className="text-warning">
                {this.props.headers.map((header, key) => {
                  return <th key={key}>{header}</th>
                })}
              </thead>
              <tbody>
                {this.props.rows.map((row, key) => {
                  return (
                    <tr key={key}>
                      {Object.keys(row).map((keyName, keyIndex) => {
                        return <td key={keyIndex}>{row[keyName]}</td>
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}
export default withRouter(Table)



// WEBPACK FOOTER //
// ./src/components/Table.js